module.exports = __webpack_public_path__ + "static/icon-mean-f6f57b38d3a58a81e21120682d6692c8.png";